class DroplandAnnouncementSlider extends HTMLElement {
  connectedCallback() {
    this.slides = [...this.querySelectorAll('[data-dropland-announcement-slide]')];
    this.previousButton = this.querySelector('[data-dropland-announcement-previous]');
    this.nextButton = this.querySelector('[data-dropland-announcement-next]');
    this.index = 0;
    this.startX = null;

    this.previousButton?.addEventListener('click', () => this.show(this.index - 1));
    this.nextButton?.addEventListener('click', () => this.show(this.index + 1));
    this.addEventListener('pointerdown', (event) => { this.startX = event.clientX; });
    this.addEventListener('pointerup', (event) => {
      if (this.startX === null) return;
      const distance = event.clientX - this.startX;
      this.startX = null;
      if (Math.abs(distance) < 36) return;
      this.show(this.index + (distance < 0 ? 1 : -1));
    });
    this.show(0);
  }

  show(index) {
    if (this.slides.length === 0) return;
    this.index = (index + this.slides.length) % this.slides.length;
    this.slides.forEach((slide, slideIndex) => {
      const active = slideIndex === this.index;
      slide.hidden = !active;
      slide.setAttribute('aria-hidden', String(!active));
    });
  }
}

if (!customElements.get('dropland-announcement-slider')) {
  customElements.define('dropland-announcement-slider', DroplandAnnouncementSlider);
}
